/* eslint-env node */

const _ = require('lodash');

var nav = {
  beer: {
    title: 'Beer',
    tag: 'BE',
    subtitle: 'The Greatest Invention In History',
    description:
      "Get your favorite beer delivered in 30-minutes! · Largest selection available · Fast Delivery · Choose from IPA's, Lagers, Pilsners, Stouts, Belgians and more"
  },
  wine: {
    title: 'Wine',
    tag: 'RW,WW,RS,SW',
    subtitle: 'The Best Wine Selection'
  },
  'red-wine': {
    title: 'Red Wine',
    tag: 'RW',
    subtitle: 'Roses Are Red. So Is Wine. Poems Are Hard. Wine.',
    description:
      'Have wine delivered in 30-minutes! · Vast Selection · Fast Delivery · Straight To Your Door · Cabernet Sauvignon, Pinot Noir, Merlot, Malbec, Zinfandel and more'
  },
  'white-wine': {
    title: 'White Wine',
    tag: 'WW',
    subtitle: 'Save Water, Drink Chardonnay',
    description:
      'Get wine delivered to your door in 30-minutes! · Vast Selection · Fast Delivery · Sauvignon Blanc, Chardonnay, Riesling and many others · 5 Star Service'
  },
  'champagne-sparkling': {
    title: 'Champagne & Sparkling',
    tag: 'SW',
    subtitle: 'For Toasts & Spraying On People',
    description:
      'Champagne delivered to your door in 30-minutes! · Incredible Selection of Champagne & Sparkling · 5-Star Service · Delivering now in your city!'
  },
  'dollar-wines': {
    title: 'Dollar Wines',
    tag: '5C',
    subtitle: 'Buy 1 Get The 2nd For $1',
    description:
      "Buy One Get One Wines! Vast Selection of top rated wines · Buy One Get the Second For $1 · Fast Delivery · It's Our Huge Wine Sale!"
  },
  spirits: {
    title: 'Spirits',
    tag: 'WS,VO,RU,TQ,GN,SP,CO',
    subtitle: 'The Best Spirits Selection'
  },
  whiskey: {
    title: 'Whiskey',
    tag: 'WS',
    subtitle: 'They Say It Makes You Frisky',
    description:
      'Get Whiskey or Scotch delivered in 30-minutes! · Vast Selection · 5-Star Service · Fast Delivery · Straight To Your Door or Great For Gifting'
  },
  vodka: {
    title: 'Vodka',
    tag: 'VO',
    subtitle: 'Trust Us, You Can Dance',
    description:
      'Have your favorite Vodka delivered to your door in 30-40 minutes! · Amazing Selection · 5-Star Service · Easily Add Mixers · Delivering in your city now!'
  },
  rum: {
    title: 'Rum',
    tag: 'RU',
    subtitle: 'It Fights Scurvy & Boosts Morale',
    description:
      'Get your favorite Rum delivered in 30-minutes! · Huge Selection of Rums · Fast Delivery · The Perfect Mixers to Make Cocktails · Delivered To Your Door'
  },
  tequila: {
    title: 'Tequila & Mezcal',
    tag: 'TQ',
    subtitle: 'Just Dont Text Your Ex',
    description:
      'Get Tequila or Mezcal delivered to your door in minutes! · Vast Selection · All The Add-ons and Mixers You Need · Delivering now in your city'
  },
  gin: {
    title: 'Gin',
    tag: 'GN',
    subtitle: 'Goes Well With Juice',
    description:
      'Get your favorite Gin delivered in 30-minutes! Huge Selection of Gins · 5-Star Service · Fast Delivery · Tons of Mixers And Add-Ons To Make Gin Cocktails'
  },
  cordials: {
    title: 'Cordials',
    tag: 'SP',
    subtitle: 'The Best Wine Selection',
    description:
      'Everything Specialty you need to make cocktails, delivered to your door! Vast Selection · 30-Minute Delivery · Bitters · Vermouth · Sake · Triple Sec · Brandy'
  },
  'cocktails-combos': {
    title: 'Cocktails & Combos',
    tag: 'CO',
    subtitle: 'Ingredients & Recipes',
    description:
      'Have Cocktails delivered straight to your door · 30-Minute delivery · Cocktail packages with all ingredients and the recipe · Manhattan, Gimlet, Martini, Mimosas and more'
  },
  mixers: {
    title: 'Mixers',
    tag: 'MX',
    subtitle: 'Ice, Soda, Juice & Everything Else',
    description:
      'Everything Mixer You Need For Alcohol Drinks! · 30-Minute Delivery · Ice · Cups · Energy Drinks · Huge Selection of Sodas · Garnishes · Juices and more!'
  },
  snacks: {
    title: 'Snacks',
    tag: 'SN',
    subtitle: 'For Your Health',
    description:
      'Have Your Favorite Snacks Delivered to Your Door in 30-Minutes! · Huge Selection · Chips · Chocolates · Crackers · Candy · Gummy Bears and more!'
  },
  'cigars-tobacco': {
    title: 'Tobacco',
    tag: 'TB',
    subtitle: 'Cigars & Cigarettes',
    description:
      'Get cigarettes delivered to your door in minutes! · Fast Delivery · Order, Cigarettes, Cigars and Tobacco along with Alcohol for delivery.'
  },
  more: { title: 'More', tag: 'MX,SN,TB', subtitle: 'For Your Health' },
  stpaddys: {
    title: "St. Paddy's Day",
    tag: 'IR',
    subtitle: 'Irish Favorites'
  },
  sake: { tag: 'SK', title: 'Sake', subtitle: 'Japanese Rice Wine' },
  'beers-of-the-month': {
    tag: 'LR',
    title: 'Beers of the Month',
    subtitle: 'Curated by October'
  },
  'me-time-whiskeys': {
    tag: 'MT',
    title: "'Me Time' Whiskeys",
    subtitle: "It's Okay to Be a Little Selfish"
  },
  'sweet-wines': {
    tag: 'SS',
    title: 'Sweet Wines',
    subtitle: 'Sweet, Just Like You'
  },
  rose: { tag: 'RS', title: 'Rosé All Day', subtitle: 'Yoga, Naps, Rosé' }
};

var map = {};
_.each(nav, function(item, k) {
  map[item.tag] = { ...item, url: k };
});

module.exports = {
  nav: nav,
  navByTag: map,
  menu: {
    baseUrl: '/menu/'
  },
  brandTemplates: {
    url: '/brand-templates/'
  },
  site: {
    url: 'https://www.saucey.com',
    defaultTitle:
      'Alcohol Delivery Near You | Beer, Wine & Liquor 30 Minutes | Saucey',
    defaultDescription:
      'Saucey has the fastest alcohol delivery near you.  No order minimums + free delivery on 30-min orders. Get beer, wine, and liquor near you delivered.'
  },
  static: {
    path: 'https://web.saucey.com'
  },
  featuredBanners: {},
  shipping: {
    freeThreshold: 150 // in dollars
  },
  courier: {
    formUrl: 'https://saucey.typeform.com/to/Ib8xTo?source=xxxxx'
  }
};
